import axios from 'axios';
import { request_mutations, request_state } from '../utils/store';
import { SIGNIN } from '../api';

export default {
    namespaced: true,
    state: request_state,
    mutations: request_mutations('signin'),
    actions: {
        signin({ commit }, payload) {
            commit('signin_loading');
            return new Promise((resolve) => {
                axios.post(SIGNIN, payload).then((response) => {
                    commit('signin_success', response.data);
                    commit('user/set_token', response.data.token, { root: true });
                    commit('user/set_user', response.data.user, { root: true });
                    resolve();
                }).catch(error => commit('signin_error', error.response.data));
            });
        },
    },
};
